import { render, staticRenderFns } from "./contactUser.vue?vue&type=template&id=05f0d60e&scoped=true"
import script from "./contactUser.vue?vue&type=script&lang=js"
export * from "./contactUser.vue?vue&type=script&lang=js"
import style0 from "./contactUser.vue?vue&type=style&index=0&id=05f0d60e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0d60e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f0d60e')) {
      api.createRecord('05f0d60e', component.options)
    } else {
      api.reload('05f0d60e', component.options)
    }
    module.hot.accept("./contactUser.vue?vue&type=template&id=05f0d60e&scoped=true", function () {
      api.rerender('05f0d60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_info/form/components/contactUser.vue"
export default component.exports